(function ($) {
    // Delegate .transition() calls to .animate()
    // if the browser can't do CSS transitions.
    if (!$.support.transition) {
        $.fn.transition = $.fn.animate;
    }
    /**
     * Locale de la page courante
     */
    var locale = $('html').attr('lang');
    /**
     * Initialisation des champs de type date
     */
    $('.type_date').datepicker($.datepicker.regional[locale]);
    /**
     * Les rubriques externes doivent s'ouvrir dans des nouvelles
     */
    $('ul:not(#menu_principal) > li > a.type_rubrique_0004').click(function (e) {
        e.preventDefault();
        window.open(this.href);
        return false;
    });
    /**
     * Permet d'associer un rôle de "fermeture" à un bouton. Code à suivre :
     * <div>
     *     <button role="close">&times;</button>
     *     <!-- ... -->
     * </div>
     */
    $(document).on('click', '[role="close"]', function (e) {
        $(this).parent().hide();
    });
    /**
     * Datagrid des résultats de recherche de formations
     */
    if ($("#resultatSelecteur")) {
        $("#resultatSelecteur").dataTable();
    }
    /**
     * Share actions
     */
    $('.js-share-action').on('click', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        window.open(href, '', 'height=400,width=600,titlebar=yes');
        return false;
    });
    // Owl Carousel
    $('.owl-carousel').each(function () {
        var $t = $(this);
        var willBeAnimated = $t.find('.item').length > 1;
        $t.owlCarousel({
            items: 1,
            margin: 10,
            loop: willBeAnimated,
            nav: false,
            autoplay: willBeAnimated,
            mouseDrag: willBeAnimated,
            touchDrag: willBeAnimated,
            autoplayTimeout: 8000,
            autoplayHoverPause: true
        });
        $t.find('.owl-controls').prepend('<button class="owl-prev">&lt;</button>').append('<button class="owl-next">&gt;</button>');
        $t.find('.owl-controls .owl-prev').click(function () {
            $t.trigger('prev.owl.carousel');
        }).end().find('.owl-controls .owl-next').click(function () {
            $t.trigger('next.owl.carousel');
        });
    });
    $('.owl-carousel_twitter').each(function () {
        var $t = $(this);
        var willBeAnimated = $t.find('.social-twitter__tweet').length > 1;
        $t.owlCarousel({
            items: 1,
            margin: 10,
            loop: willBeAnimated,
            nav: false,
            autoplay: false,
            mouseDrag: willBeAnimated,
            touchDrag: willBeAnimated,
            autoplayTimeout: 8000,
            autoplayHoverPause: true
        });
        $t.find('.owl-controls').prepend('<button class="owl-prev"></button>').append('<button class="owl-next"></button>');
        $t.find('.owl-controls .owl-prev').click(function () {
            $t.trigger('prev.owl.carousel');
        }).end().find('.owl-controls .owl-next').click(function () {
            $t.trigger('next.owl.carousel');
        });
    });

    /*$.dataToggle.init({
        preventingCallback: function($that, $target, $el, options) {
            return (
                $el.parents('.kTree').length > 0 ||
                $el.parents('.ui-dialog').length > 0 ||
                $el.parents('.plier-deplier').length > 0 ||
                $el.parents('.owl-carousel').length > 0 ||
                $el.parents('.owl-thumbs').length > 0 ||
                $el.parents('.tag-formation').length > 0 ||
                $el.parents('.banner_cookie').length > 0 ||
                $el.parents('.pied_page__complement').length > 0 ||
                $el.parents('.formulaire_redacteur').length > 0 ||
                $el.parents('.saisiefront [role="main"]').length > 0 ||
                $el.parents('.recherche_avancee').length > 0 ||
                $el.parents('.cookie-banner').length > 0 ||
                $el.is('select') ||
                $el.parents('.onglets-section').length > 0 ||
                $el.parents('.paragraphe--4').length > 0
            )
        }
    });*/
    function matches(el, selector) {
        if (!el) {
            return false;
        }
        var matchesCallable = (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector);
        if (!matchesCallable) {
            return false;
        }
        return matchesCallable.call(el, selector);
    }

    function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
    }

    function parentMatches(el, selector) {
        return closest(el, function (e) {
            return matches(e, selector);
        }) != null;
    }

    function ancestorIndex(el, selector) {
        var index = 0;
        while (el !== null && !matches(el, selector)) {
            el = el.parentNode;
            index++;
        }
        if (el === null) {
            return null;
        } else {
            return index;
        }
    }

    // Data-toggle init
    const dataToggleInstance = new DataToggle({
        preventingCallback: function ($element, $target, $el) {
            /*
             * L'apposition de l'attribut data-toggle-target sur un item
             * empêche le déclenchement d'un data-toggle englobant.
             *
             * Par exemple, pour fermer un dropdown ouvert, on doit poser
             * un data-toggle sur le body. Or, comme le body englobe
             * le dropdown, le clic à l'intérieur de la zone du dropdown
             * a pour effet de le fermer, ce qui n'est pas souhaitable.
             * En ajoutant l'attribut data-toggle-target sur le dropdown,
             * on empêche donc l'exécution du mécanisme de data-toggle
             * à l'intérieur de celui-ci.
             *
             * Toutefois, il peut y avoir besoin d'ajouter des
             * data-toggle à l'intérieur d'un dropdown. C'est pourquoi,
             * il est nécessaire de contrôler que si le clic se trouve
             * dans une zone "restreinte" par le data-toggle-target, il
             * faut quand même autoriser l'action du data-toggle. Cela
             * peut donc se déduire, grâce à l'arborescence du HTML : si
             * le parent le plus proche de l'élément sur lequel est
             * intervenu le clic est un data-toggle et non un
             * data-toggle-target, alors on peut autoriser l'action du
             * data-toggle.
             */
            if (parentMatches($el, '[data-toggle-target]')) {
                var parentDataToggleTarget = ancestorIndex($el, '[data-toggle-target]');
                var parentDataToggle = ancestorIndex($el, '[data-toggle]');
                if (parentDataToggle === null) {
                    return true;
                } else {
                    return parentDataToggleTarget < parentDataToggle;
                }
            } else if (matches($el, '.autocomplete-suggestions') || parentMatches($el, '.autocomplete-suggestions')) {
                return true;
            }
            return false;
        }
    });
    // Give focus to controls inside top-bar menus when they are opened
    [].forEach.call(document.querySelectorAll('[data-toggle-id="search-form"]'), function (element) {
        element.addEventListener('give-focus', function () {
            var inputs = element.querySelectorAll('input:not([type=hidden]),select,textarea,button,a[href]');
            if (inputs.length > 0) {
                inputs[0].focus();
            }
        });
    });

    function bindEnableFirstSubItemOnMenuOpen() {
        /*
     * Activation par défaut du 1er sous-menu du jeu de jsp 2021 lors du clic sur un item du menu.
     */
        [].forEach.call(document.querySelectorAll('.menu__item-level--0 .menu__item-label'), function (element) {
            element.addEventListener('click', function () {
                var subMenu = element.nextElementSibling;
                var elementSubMenuItem = subMenu.querySelectorAll(".submenu-level--2");
                [].forEach.call(elementSubMenuItem, function (el, index) {
                    if (index == 0) {
                        el.classList.add("active");
                    } else {
                        el.classList.remove("active");
                    }
                });
                var elementSubMenu = subMenu.querySelectorAll(".submenu__item-level--2");
                [].forEach.call(elementSubMenu, function (el, index) {
                    if (index == 0) {
                        el.classList.add("active");
                    } else {
                        el.classList.remove("active");
                    }
                });
            });
        });

        /*
         *
         */
        [].forEach.call(document.querySelectorAll('.menu__item-level--1 .menu__item-label'), function (element) {
            element.addEventListener('click', function () {
                var subMenu = element.nextElementSibling;
                var elementSubMenuItem = subMenu.querySelectorAll(".submenu-level--3");
                [].forEach.call(elementSubMenuItem, function (el, index) {
                    if (index == 0) {
                        el.classList.add("active");
                    } else {
                        el.classList.remove("active");
                    }
                });
                var elementSubMenu = subMenu.querySelectorAll(".submenu__item-galaxie");
                [].forEach.call(elementSubMenu, function (el, index) {
                    if (index == 0) {
                        el.classList.add("active");
                    } else {
                        el.classList.remove("active");
                    }
                });
            });
        });
    }

    $(".paragraphe__titre--4").click(function () {
        $(this).next().slideToggle(250).parent().toggleClass("active");
    });

    $(".document__list-heading").click(function () {
        $(this).children(".document__list-details").slideToggle(250).parent().toggleClass("active");
        event.stopPropagation();
    });

    //Mise en forme des listes
    $("#page .objets:not(.annuaire) .avec_vignette:not(tr)").each(function () {
        if (!$(this).find(".vignette_deco").length) {
            $(this).prepend("<div class='vignette_deco'></div>"); //- Forcer une image générique si non présente sur les styles avec vignette
        }
    });
    //traitement spécifique sur les flux rss
    $("#page .objets.fluxrss .avec_vignette").each(function () {
        var vignette = $(this).find(".vignette_deco");
        var contentimg = $(this).find("img");
        console.log(contentimg.attr("src"));
        if (vignette.attr("style") == undefined) {
            vignette.css("background-image", "url('" + contentimg.attr("src") + "')");
            contentimg.remove();
        }
    });
    //Traitement spécifique carte twitter accueil
    $(".ficheaccueil .focusCard").parents(".layout__simple-grid").addClass("hasFocusCard");
    $(".ficheaccueil .vousetesCard").parents(".layout__simple-grid").addClass("hasVousetesCard");
    $(".ficheaccueil .twitter-card").parents(".layout__simple-grid").addClass("hasTwitterCard");
    //Mise en forme des encadrés auto
    $("#encadres>div:first-child.encadre_auto_fiche").addClass("encadre--1");
    //sticky
    var throttle = function (func, wait, options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        if (!options) {
            options = {};
        }
        var later = function () {
            previous = options.leading === false ? 0 : +new Date;
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) {
                context = args = null;
            }
        };
        return function () {
            var now = +new Date;
            if (!previous && options.leading === false) {
                previous = now;
            }
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) {
                    context = args = null;
                }
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    };
    $(window).on('scroll load', throttle(function scrollSpy() {
        toogleHeader();
    }, 100));

    function toogleHeader() {
        $('body').toggleClass('alt-header', $(window).scrollTop() > 65);
    }

    //Gestion du cssCalc
    $(window).load(function () {
        if ($("html").hasClass("csscalc")) {
            $("body").removeClass("nocalc").addClass("loaded");
        }
    });
    //Toogle header au resize
    $(window).resize(function () {
        toogleHeader();
    });

    //scroll smooth - fiche formation
    var ScrollTo = function (options) {
        function extend() {
            for (var i = 1; i < arguments.length; i++) {
                for (var key in arguments[i]) {
                    if (arguments[i].hasOwnProperty(key)) {
                        arguments[0][key] = arguments[i][key];
                    }
                }
            }
            return arguments[0];
        }

        function forEach(elements, callback) {
            return [].forEach.call(elements, callback);
        }

        function query(selector, callback) {
            return forEach(document.querySelectorAll(selector), callback);
        }

        var instance = {
            options: {
                scroller: {
                    get: function () {
                        var supportPageOffset = window.pageXOffset !== undefined;
                        var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
                        return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
                    },
                    set: function (position) {
                        window.scroll(0, position);
                    }
                },
                triggerSelector: '[data-scroll-to]',
                targetSelection: function (element) {
                    return element.getAttribute('data-scroll-to') || element.getAttribute('href');
                },
                durationAttr: function (element) {
                    return element.getAttribute('data-scroll-to-duration');
                },
                yfixAttr: function (element) {
                    return element.getAttribute('data-scroll-to-yfix');
                },
                yFix: 0,
                duration: 2000
            },
            __construct: function (options) {
                this.options = extend(this.options, options || {});
                this.bindElements.call(this);
            },
            bindElements: function () {
                var self = this;
                query(this.options.triggerSelector, function (element) {
                    element.addEventListener('click', function (e) {
                        e.preventDefault();
                        var trigger = e.currentTarget;
                        if (!trigger) {
                            return false;
                        }
                        var target = self.options.targetSelection(trigger);
                        var duration = self.options.durationAttr(trigger) || self.options.duration;
                        var yFix = self.options.yfixAttr(trigger) || self.options.yFix;
                        var scrollPosition = self.options.scroller.get();
                        var scrollDestination = (function getOffsetTop(elem, defaultValue) {
                            if (elem) {
                                var offsetTop = 0;
                                do {
                                    if (!isNaN(elem.offsetTop)) {
                                        offsetTop += elem.offsetTop;
                                    }
                                } while (elem = elem.offsetParent);
                                return offsetTop;
                            } else {
                                return defaultValue;
                            }
                        })(document.querySelector(target), scrollPosition) - yFix;
                        animate(function (value) {
                            self.options.scroller.set(value);
                        }, scrollPosition, scrollDestination, duration, 'easeOutQuad');
                        return false;
                    });
                });
            }
        };

        instance.__construct(options);
        return instance;
    };

    new ScrollTo({
        yFix: 136,
        duration: 2000
    });

    // Scrollspy
    var scrollSpyFix = 136;

    // border-bottom-color sur les onglets du menu formation au scroll
    var bindScrollSpy = function () {
        [].forEach.call(document.querySelectorAll('[data-scrollspy]'), function (element) {
            var $target = document.querySelector(element.getAttribute('data-scrollspy'));
            if (!!$target) {
                var rect = $target.getBoundingClientRect();

                if (Math.floor(+rect.top) <= scrollSpyFix && Math.floor(+rect.bottom - 1) > scrollSpyFix) {
                    if (!element.classList.contains('current')) {
                        element.classList.add('current');
                    }
                } else {
                    if (element.classList.contains('current')) {
                        element.classList.remove('current');
                    }
                }
            }
        });
    };
    window.addEventListener('scroll', throttle(bindScrollSpy, 20));

    var getAbsoluteRectFor = function (element) {
        var rect = element.getBoundingClientRect();
        var bodyRect = document.body.getBoundingClientRect();
        return {
            top: rect.top - bodyRect.y,
            bottom: rect.bottom - bodyRect.y,
            left: rect.left - bodyRect.x,
            right: rect.right - bodyRect.x
        };
    };

    window.__uca_parcours_position = function () {
        if (document.querySelector('.jumps__inner.ui-sticky').classList.contains('ui-sticky-show')) {
            return document.querySelector('.jumps__inner.ui-sticky [data-id="parcours-card-button"]');
        } else {
            return document.querySelector('.formation-header [data-id="parcours-card-button"]');
        }
    };

    window.__uca_parcours_listen = function (callback) {
        Array.from(document.querySelectorAll('.jumps__inner-list')).forEach(function ($el) {
            $el.addEventListener('resize', callback);
            $el.addEventListener('scroll', callback);
        });
        Array.from(document.querySelectorAll('[data-id="parcours-card-dropdown"]')).forEach(function ($el) {
            $el.addEventListener('toggleparcours', ({detail: [status]}) => {
                if (status) {
                    if (document.querySelector('.jumps__inner.ui-sticky').classList.contains('ui-sticky-show')) {
                        document.querySelector('.ui-sticky [data-toggle-event="toggleparcours"]').scrollIntoView({
                            behavior: 'instant',
                            block: 'nearest',
                            inline: 'nearest'
                        });
                    } else {
                        document.querySelector('.formation-header [data-toggle-event="toggleparcours"]').scrollIntoView({
                            behavior: 'instant',
                            block: 'nearest',
                            inline: 'nearest'
                        });
                    }
                }
                callback();
            });
        });
    };

    // Position relative detached
    var bindPositionParent = function () {
        function reposition(parent, child, align) {
            // console.log('reposition')
            var parentPositionRect = getAbsoluteRectFor(parent());
            Object.entries(align).forEach(function ([anchor, ref]) {
                var value = parentPositionRect[ref];
                if (anchor === 'bottom') {
                    value = document.body.clientHeight - value;
                } else if (anchor === 'right') {
                    value = document.body.clientWidth - value;
                }
                child.style[anchor] = value + 'px';
            });
        }

        [].forEach.call(document.querySelectorAll('[data-position-parent]'), function ($element) {
            var $parent = $element.getAttribute('data-position-parent');
            var parentCallback = () => {
                var $p;
                if (/^func:/.test($parent)) {
                    $p = window[$parent.replace(/^func:/, '')]();
                } else {
                    $p = document.querySelector($parent)
                }
                return $p;
            };
            try {
                var align = JSON.parse($element.getAttribute('data-position-align'));
                reposition(parentCallback, $element, align);
                $element.classList.add('ui-detached-relative');
                body.appendChild($element);

                var callback = throttle(() => reposition(parentCallback, $element, align), 2, {trailing: true});
                window.addEventListener('scroll', callback);
                window.addEventListener('resize', callback);
                var $elementsToListen = $element.getAttribute('data-position-listen');
                if (/^func:/.test($elementsToListen)) {
                    window[$elementsToListen.replace(/^func:/, '')](callback);
                } else {
                    Array.from(document.querySelectorAll($elementsToListen)).forEach(function ($etl) {
                        $etl.addEventListener('scroll', callback);
                        $etl.addEventListener('resize', callback);
                    });
                }
            } catch (e) {
                console.error('Malformed align data', e);
            }
        });
    };


    /* ouverture/fermeture des accordeons */
    const headings = document.getElementsByClassName('accordion__list-heading');
    Array.prototype.forEach.call(headings, heading => {
        let btn = heading.querySelector('button');
        let target = heading.nextElementSibling;

        if (btn && target) {
            btn.onclick = () => {
                // Fermer les éléments voisins pour n'en garder qu'un seul ouvert dans le plan de site en encadrés
                if (btn.closest('#encadres') !== null) {
                    const list = btn.closest('ul');
                    for (const el of Array.from(list.querySelectorAll(':scope > li > .accordion__list-heading'))) {
                        if (el === heading) continue;
                        const elBtn = el.querySelector('button');
                        const elTarget = el.nextElementSibling;
                        if (elBtn && elTarget) {
                            elBtn.setAttribute('aria-expanded', false);
                            elTarget.hidden = true;
                        }
                    }
                }

                // Basculer l'affichage d'un item
                let expanded = btn.getAttribute('aria-expanded') === 'true' || false;
                btn.setAttribute('aria-expanded', !expanded);
                target.hidden = expanded;

                // Fermer les enfants si besoin
                if (!expanded) {
                    for (const el of Array.from(target.querySelectorAll('.accordion__list-heading'))) {
                        const elBtn = el.querySelector('button');
                        const elTarget = el.nextElementSibling;
                        if (elBtn && elTarget) {
                            elBtn.setAttribute('aria-expanded', false);
                            elTarget.hidden = true;
                        }
                    }
                }
            }
        }
    });

    window.__uca_header_clone = (el, stickyEl) => {
        stickyEl.querySelector('[data-toggle-id="search-form"]').setAttribute('data-toggle-id', 'search-form-sticky');

        [].forEach.call(document.querySelectorAll('[data-toggle-id="search-form-sticky"]'), function (element) {
            element.addEventListener('give-focus-sticky', function () {
                var inputs = element.querySelectorAll('input:not([type=hidden]),select,textarea,button,a[href]');
                if (inputs.length > 0) {
                    inputs[0].focus();
                }
            });
        });
    };

    let previousStickyStatus = false;
    window.__uca_jumps_clone = (el, stickyEl, event, data) => {
        switch (event) {
            case 'init': {
                Array.from(stickyEl.querySelectorAll('.parcoursCard') || []).forEach(e => e.classList.add('ui-cloned'));
                break
            }
            case 'toggle': {
                if (data !== previousStickyStatus) {
                    Array.from(document.querySelectorAll('.cta.active') || []).forEach(e => e.classList.remove('active'));
                    previousStickyStatus = data;
                }
                break
            }
        }
    };

    var bindStickyElements = function () {
        const stickyElements = Array.from(document.querySelectorAll('[data-sticky]'));
        for (let el of stickyElements) {
            const id = 'sticky-' + (el.getAttribute('data-sticky') || Date.now());
            const parent = el.getAttribute('data-sticky-parent') || null;
            const parentElement = document.querySelector(parent) || el.parentNode;
            const scrollObserve = el.getAttribute('data-sticky-scroll-observe') || 'window';
            const hookCallback = el.getAttribute('data-sticky-hook') || ((el, stickyEl) => {
            });
            let scrollObserveElement = window;
            if (scrollObserve && scrollObserve !== 'window') {
                scrollObserveElement = document.querySelector(scrollObserve);
            }
            const stickyEl = el.cloneNode(true);
            stickyEl.classList.add('ui-sticky');
            stickyEl.setAttribute('data-sticky-id', id);
            stickyEl.removeAttribute('data-sticky');
            stickyEl.removeAttribute('data-sticky-parent');
            stickyEl.removeAttribute('data-sticky-scroll-observe');
            parentElement.appendChild(stickyEl);
            if (typeof window[hookCallback] === typeof Function) {
                window[hookCallback](el, stickyEl, 'init');
            }
            const refreshStickyDisplay = throttle(() => {
                const elBounds = el.getBoundingClientRect();
                const scrollObserveBounds = scrollObserve === 'window' ? {
                    height: scrollObserveElement.innerHeight,
                    width: scrollObserveElement.innerWidth
                } : scrollObserveElement.getBoundingClientRect();
                const stick = !(
                    elBounds.top >= 0 &&
                    elBounds.bottom <= scrollObserveBounds.height &&
                    elBounds.left >= 0 &&
                    elBounds.right <= scrollObserveBounds.width
                );
                // DEBUG: console.log({ top: elBounds.top, bottom: elBounds.bottom, left: elBounds.left, right: elBounds.right, stick, height: scrollObserve.height, width: scrollObserve.width })
                stickyEl.classList.toggle('ui-sticky-show', stick);
                stickyEl.classList.toggle('ui-sticky-hide', !stick);
                if (typeof window[hookCallback] === typeof Function) {
                    window[hookCallback](el, stickyEl, 'toggle', stick);
                }
            }, 20);
            scrollObserveElement.addEventListener('scroll', refreshStickyDisplay);
            window.addEventListener('resize', refreshStickyDisplay);
            refreshStickyDisplay();
        }
    };

    var bindScrollHider = function () {
        var lastScrollTop = 0;
        var header = document.querySelector('.header');
        window.addEventListener('scroll', function () {
            var st = window.pageYOffset || document.documentElement.scrollTop;
            header.classList.toggle('header--hidden', st > lastScrollTop);
            lastScrollTop = st <= 0 ? 0 : st;
        }, false);
    };

    var bindScrollHiderJump = function () {
        var lastScrollTopJump = 0;
        var jumpinner = document.querySelector('.jumps__inner.ui-sticky');
        if (jumpinner) {
            window.addEventListener('scroll', function () {
                var stJump = window.pageYOffset || document.documentElement.scrollTop;
                jumpinner.classList.toggle('jump--hidden', stJump > lastScrollTopJump);
                lastScrollTopJump = stJump <= 0 ? 0 : stJump;
            }, false);
        };
    };

    // Handle sticky elements
    window.addEventListener('load', function () {
        bindStickyElements(); // Branchement des éléments sticky sur la page
        bindEnableFirstSubItemOnMenuOpen(); // Activation de l'ouverture du premier sous-menu au clic sur un item du menu principal
        bindPositionParent(); // Branchement des éléments positionés en absolu sur la page, mais relatif à un élément spécifique
        dataToggleInstance.refresh(); // RafraÎchissement des événements du Data Toggle
        bindScrollHider();
        bindScrollHiderJump();

        // Branchement de PetiteVue sur les éléments de la page qui l'utilisent
        const menuReactive = PetiteVue.reactive({
            currentMenu: null,
            currentSubMenu: null,
            displaySearch: false,
            toggleMenu(menu, subMenu) {
                this.currentMenu = this.currentMenu === menu ? '' : menu;
                this.toggleSubMenu(menu === '' ? '' : subMenu);
            },
            toggleSubMenu(subMenu) {
                this.currentSubMenu = subMenu;
            },
            hideAll() {
                this.currentMenu = '';
                this.currentSubMenu = '';
                this.displaySearch = false;
            },
            toggleSearch(element) {
                this.displaySearch = !this.displaySearch;
                PetiteVue.nextTick(() => {
                    element.parentElement.querySelector('input[name=q]').focus();
                });
            }
        });

        function clickAwayDirective({el, get}) {
            const listener = (event) => {
                const elHeader = document.querySelector('header .header__main');
                // const elStickyHeader = document.querySelector('.ui-sticky[data-sticky-id="sticky-header"]');

                // const isAltHeader = document.body.classList.contains('alt-header');

                const elRechercheHeader = elHeader.querySelector('.recherche-simple');
                // const elRechercheSticky = elStickyHeader.querySelector('.recherche-simple');

                // Éviter le double appel à cause de la duplication de flux pour l'affichage en sticky
                /* if (isAltHeader) {
                    if (elStickyHeader.contains(el) && !(el.contains(event.target)) && !(elRechercheSticky.contains(event.target))) {
                        get();
                    }
                } else { */
                if (
                    elHeader.contains(el) && !(el.contains(event.target)) && !(elRechercheHeader.contains(event.target))
                ) {
                    get();
                }
                // }
            };

            document.addEventListener("click", listener);

            return () => {
                document.removeEventListener(listener);
            };
        }

        PetiteVue.createApp({menuReactive}).directive("click-away", clickAwayDirective).mount();
    });

    $(".button__recherche-simple").click(function () {
        $(this).toggleClass("active");
        $(".button__recherche-simple .icon-close").toggleClass("active");
    });

    let el = document.querySelector("#search-bar-header");
    if (el) {
        el.addEventListener("click", function (event) {
            let target = event.currentTarget;
            if (target.getAttribute("aria-expanded") === "true") {
                target.setAttribute("aria-expanded", "false");
            } else { // collapsed
                target.setAttribute("aria-expanded", "true");
            }
        });
    }

    // pr menu mobile
    $(".burger-menu__input").click(function (event) {
        event.stopPropagation();
        $(".menu-item--has-children").removeClass("active");
        $(".submenu__content--mobile").removeClass("active");
    });

    $(".menu-mobile--back-link").click(function (event) {
        event.stopPropagation();
        $(this).closest('.active').first().removeClass("active");
    });

    $(".menu-item--has-children").click(function (event) {

        if ($(event.target).hasClass('menu__item-link--has-children')) {
            event.stopPropagation();
            $(this).toggleClass("active");
            $(this).children(".submenu__content--mobile").toggleClass("active");
        }

    });

    $(".menu__item-level--0 .menu-item--has-children.active").click(function (event) {
        event.stopPropagation();
        $(".menu__item-level--0 .submenu__content--mobile.active").removeClass("active");
    });

    // pr carrousel styles de liste
    /**
     * Retourne la largeur d'une "page"
     * @param $zone Élément qui englobe les items du carrousel
     * @returns {number} Largeur à faire défiler
     */
    function getPageWidth($zone) {
        return $zone.clientWidth / 2 // <= Permet de s'assurer qu'on ne va pas sauter un item
    }

    /**
     * Met à jour l'affichage du carrousel
     * @param $wrapper Élément parent du carrousel
     * @param $zone Élément qui englobe les items du carrousel
     * @param $previous Boutons de pagination en arrière
     * @param $next Boutons de pagination en avant
     */
    function updateScrollerUI($wrapper, $zone, $previous, $next) {
        // Par défaut, on désactive les boutons de pagination
        let isPreviousEnabled = false
        let isNextEnabled = false

        // Si les items ne peuvent pas être tous affichés
        if ($zone.scrollWidth > $zone.clientWidth) {
            // On indique la possibilité de retourner en arrière
            isPreviousEnabled = $zone.scrollLeft > 0
            // On indique la possibilité d'aller en avant
            isNextEnabled = $zone.scrollLeft < ($zone.scrollWidth - $zone.clientWidth)
        }

        // Mise à jour de l'état des boutons précédent et suivant
        for (const $p of $previous) {
            $p.disabled = !isPreviousEnabled
        }
        for (const $n of $next) {
            $n.disabled = !isNextEnabled
        }
        // Ajout et suppression des classes dédiées
        $wrapper.classList.toggle('is-at-start', !isPreviousEnabled)
        $wrapper.classList.toggle('is-at-end', !isNextEnabled)
    }

    /**
     * Initialise le carrousel
     * @param $wrapper Élément parent du carrousel
     */
    function bindScroller($wrapper) {
        // $zone : Élément qui englobe les items du carrousel
        // $previous : Boutons de pagination en arrière
        // $next : Boutons de pagination en avant
        // $items : Items du carrousel
        // $itemsClickableZones : Zone cliquable des items du carrousel
        const $zone = $wrapper.querySelector('[data-scroller-zone]')
        const $previous = Array.from($wrapper.querySelectorAll('[data-scroller-previous]'))
        const $next = Array.from($wrapper.querySelectorAll('[data-scroller-next]'))
        const $items = Array.from($wrapper.querySelectorAll('[data-scroller-item]'))
        const $itemsClickableZones = Array.from($wrapper.querySelectorAll('[data-scroller-item-clickable-zone]'))

        // Au chargement de la page, on remet le carrousel au début
        $zone.scrollLeft = 0

        // Prise en charge des boutons de pagination en arrière
        for (const $p of $previous) {
            $p.addEventListener('click', () => {
                const left = getPageWidth($zone) * -1
                $zone.scrollBy({ left })
            })
        }

        // Prise en charge des boutons de pagination en avant
        for (const $n of $next) {
            $n.addEventListener('click', () => {
                const left = getPageWidth($zone)
                $zone.scrollBy({ left })
            })
        }

        // Quand les zones cliquables des items reçoivent le focus, on les déplace au centre pour s'assurer de leur bonne visibilité
        for (const $i of $itemsClickableZones) {
            $i.addEventListener('focus', () => {
                $i.scrollIntoView({ block: 'nearest', inline: 'center' })
            })
        }

        // En cas de resize ou scroll du wrapper, on met à jour l'interface du carrousel
        new ResizeObserver(() => updateScrollerUI($wrapper, $zone, $previous, $next)).observe($zone)
        $zone.addEventListener('scroll', () => updateScrollerUI($wrapper, $zone, $previous, $next))
        // Premier appel pour initialisation
        updateScrollerUI($wrapper, $zone, $previous, $next)
    }

    // On déclenche l'initialisation des carrousels quand la page est prête
    window.addEventListener('load', () => {
        const $scrollers = Array.from(document.querySelectorAll('.js-scroller'))
        for (const $scroller of $scrollers) {
            bindScroller($scroller)
        }
    })

})(jQuery.noConflict());
